import { select, Store } from "@ngrx/store";
import { debounceTime } from "rxjs/operators";
import { BaseDataSource } from "../../_base/crud";
import { AppState } from "../../reducers";
import { PromotionRequisiteModel } from "./promotion-requisite.model";
import { selectRequisitesInStore, selectRequisitesShowInitWaitingMessage } from "./promotion-requisites.selectors";

export class PromotionRequisitesDatasource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.store
      .pipe(select(selectRequisitesInStore), debounceTime(600))
      .subscribe((response: PromotionRequisiteModel[]) => {
        this.entitySubject.next(response);
      });

    this.isPreloadTextViewed$ = this.store.pipe(select(selectRequisitesShowInitWaitingMessage));
  }
}
